/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { update } from '../../services/item';
import { deepCloneArray } from '../../utils/array';
import { getId } from '../../utils/item';
import { NumSettingsFormula } from './num.SettingsFormula';
import {
  WidgetSettingsRoot,
  WidgetSettingsCollapsibleSection,
  HelpMarkdownSection,
  SettingsInput,
  SettingsRow,
  DangerZone,
} from '../form/settings.Widget';

export const NumSettings = props => {
  const { num, itemId, numId, updateField, value, modalId } = props;

  const item = useSelector(state => state.items[itemId]);

  const deleteNum = () => {
    const clonedNums = deepCloneArray(item.has_num);
    const idx = clonedNums.findIndex(numObj => getId(numObj) === numId);
    if (idx > -1) {
      clonedNums.splice(idx, 1);
      update(`items/${itemId}`, 'has_num', clonedNums);
    }
  };

  return (
    <WidgetSettingsRoot>
      <WidgetSettingsCollapsibleSection
        title='Général'
        defaultOpen={true}
      >
        <div className='flex flex-col gap-05 text-contrast'>
          <SettingsRow
            label='Label'
            dense
          >
            <SettingsInput
              placeholder={'label'}
              initValue={num.label}
              onBlur={value => updateField(value, 'label')}
            />
          </SettingsRow>

          {/* TODO when filter ready
        Use type to order items by a type of number
        (see what to do with mutliples numbers with the same type on the same item)
        */}
          {/* <div className='flex flex-1 items-center gap-05'>
          <div className='ml-1'>Type</div>
          <SettingsInput
            placeholder={'type'}
            initValue={num.type}
            onBlur={value => updateField(value, 'type')}
          />
        </div> */}

          <SettingsRow
            label='Valeur'
            dense
          >
            <SettingsInput
              placeholder={'value'}
              initValue={num.value}
              onBlur={value => updateField(value, 'value')}
            />
          </SettingsRow>
        </div>
      </WidgetSettingsCollapsibleSection>

      <HelpMarkdownSection
        value={num?.tooltip ?? null}
        onChange={value => updateField(value, 'tooltip')}
        previewTextId={numId + '-tooltip-preview'}
        previewItemId={itemId}
        defaultOpen={false}
      />

      <WidgetSettingsCollapsibleSection
        title='Formule'
        defaultOpen={false}
      >
        <NumSettingsFormula
          num={num}
          itemId={itemId}
          numId={numId}
          updateField={updateField}
          value={value}
        />
      </WidgetSettingsCollapsibleSection>

      <WidgetSettingsCollapsibleSection
        title='Contraintes'
        defaultOpen={false}
      >
        <div className='flex flex-col gap-05 text-contrast'>
          <div
            className='flex gap-05 items-center cursor-pointer transition hover:opacity-50'
            onClick={() => updateField(num.rounded ? false : true, 'rounded')}
          >
            {num.rounded ? <FaCheck /> : <FaTimes />} Arrondis ?
          </div>
          <div
            className='flex gap-05 items-center cursor-pointer transition hover:opacity-50'
            onClick={() =>
              updateField(
                num.timelineDraggable ? false : true,
                'timelineDraggable',
              )
            }
          >
            {num.timelineDraggable ? <FaCheck /> : <FaTimes />} Autoriser le
            drag vers une timeline
          </div>

          <div className='flex flex-col sm:flex-row gap-05'>
            <SettingsRow
              label='minimum'
              dense
            >
              <SettingsInput
                placeholder={'minimum'}
                className='w-full'
                initValue={num.min}
                onBlur={value => updateField(value, 'min')}
              />
            </SettingsRow>

            <SettingsRow
              label='maximum'
              dense
            >
              <SettingsInput
                placeholder={'maximum'}
                className='w-full'
                initValue={num.max}
                onBlur={value => updateField(value, 'max')}
              />
            </SettingsRow>
          </div>
        </div>
      </WidgetSettingsCollapsibleSection>
      <DangerZone
        confirmId={'delete' + numId + itemId}
        closeModalId={modalId || `numSettings:${itemId}:${numId}`}
        message='Voulez-vous vraiment supprimer ce nombre ?'
        onConfirm={deleteNum}
      />
    </WidgetSettingsRoot>
  );
};
